import Draggable from 'react-draggable';
import ControlBar from '../Utils/ControlBar.jsx';
import wdbIcon from '../../Graphics/WDBlogo.jpeg';
import bmunIcon from '../../Graphics/bmun_icon.jpeg';
import csIcon from '../../Graphics/ai61A.png';
import nexaIcon from '../../Graphics/Nexa.jpeg';

function AcademicsFile({mobile, display, setDisplay, z, changeOrder}) {
    const offSetX = mobile ? window.innerWidth * (.5 / 12) : window.innerWidth / 2 + 60;;
    const offSetY = mobile ? 910 : 20;
    const width = mobile ? 'w-11/12' : 'w-4/12';
    const mainStyle = `absolute overflow-auto rounded-sm ${width}`;
    return (
        display ?
        <div class={z} onMouseDown={() => changeOrder()}>
            <Draggable
                handle=".handle"
                defaultPosition={{x: offSetX, y: offSetY}}
                bounds={{top:0, bottom:null, left:null, right:null}}
            >
                <div className={mainStyle}>
                    <ControlBar name={"Experience"} setDisplay={setDisplay}/>
                    <div className="flex flex-col gap-4 h-[548px] border-x-4 border-b-4 border-black overflow-auto bg-white rounded-bl-md rounded-br-md p-5">
                        <h2 class="font-bold text-3xl">Academic Involvements:</h2>
                        <div>
                            <h3 class="italic font-semibold">Web Development at Berkeley</h3>
                            <div class="flex flex-row items-center gap-5">
                                <p class="text-sm">
                                    As an industry developer, I work with various fast-paced startups 
                                    to help build their products. In my most recent project, working with company 
                                    Tickerzone, I developed multiple React pages for a real-time stock market 
                                    investment tracking platform. Also, I integrated PostHog analytics into the 
                                    website to capture user behavior and performance metrics.
                                </p>
                                <img src={wdbIcon} class="w-20 h-20 rounded-full text-wrap"/>
                            </div>
                        </div>
                        <div>
                            <h3 class="italic font-semibold">Berkeley Model United Nations</h3>
                            <div class="flex flex-row items-center gap-5">
                                <p class="text-sm">
                                    I developed a registration website for the largest Model United Nations 
                                    conference on the west coast (2000 annual attendees) which handles hundreds 
                                    of monthly active users and securely stores their associated data. Previously, 
                                    as the Deputy Treasurer and later the CFO, I helped automate the organization’s 
                                    invoice and payment tracking system (via the QuickBooks Online API) to organize 
                                    the 6 figures of annual revenue generated by our conferences; I developed and 
                                    managed the associated annual budget.
                                </p>
                                <img src={bmunIcon} class="w-20 h-20 rounded-full text-wrap"/>
                            </div>
                        </div>
                        <div>
                            <h3 class="italic font-semibold">Course Staff - UC Berkeley CDSS</h3>
                            <div class="flex flex-row items-center gap-5">
                                <p class="text-sm">
                                    As a reader/tutor for the Discrete Mathematics and Probability Theory course I 
                                    assisted students during office hours and discussion sections, provided individual 
                                    and group support on homework, practice sheets, and general course material along 
                                    with having graded homework assignments and exams. As an academic intern for our 
                                    Computer Programs course I provided one-on-one tutoring for Berkeley's largest computer 
                                    science course with a class size of over 1500 students and I taught programming concepts 
                                    such as recursion, currying and data structures using Python, Scheme, and SQL.
                                </p>
                                <img src={csIcon} class="w-20 h-20 rounded-full text-wrap" />
                            </div>
                        </div>
                        <div>
                            <h3 class="italic font-semibold">BOBA Lab</h3>
                            <div class="flex flex-row items-center gap-5">
                                <p class="text-sm">
                                    As a research assistant, I conducted exploratory data analysis to identify distinct 
                                    learning styles and how to accelerate learning as a whole.
                                </p>
                                <img src={csIcon} class="w-20 h-20 rounded-full text-wrap" />
                            </div>
                        </div>
                    </div>
                </div>
            </Draggable>
        </div>
        : null
    )
}

export default AcademicsFile;